<template lang="html">
    <div id="SalesStatistical"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.7)"
    >
        <div style="width: 100%;height: 100%">
            <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
                <el-col :span="6">
                    <span>月份</span>
<!--                    <el-date-picker-->
<!--                            v-model="month"-->
<!--                            format="yyyy年MM月"-->
<!--                            value-format="yyyy-MM"-->
<!--                            type="month"-->
<!--                            @change="getProductList"-->
<!--                            placeholder="选择月">-->
<!--                    </el-date-picker>-->
                    <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                </el-col>
                <el-col :span="6">
                    <span>产品</span>
                    <el-select v-model="value1" style="width:70%" placeholder="全部产品">
                        <el-option
                                v-for="item in productList"
                                :key="item.product_id"
                                :label="item.product_name"
                                :value="item.product_id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="12" v-if="role!='staff'">
                    <div style="float: right">
                        <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                        <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="searchWeekList">查询</el-button>
                <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportClick">
                    导出数据
                </el-button>
            </el-row>
            <el-row>
                <el-col>
                    <p style="font-size: 21px;color: #000;">{{yearsDate}}<span style="font-size: 16px;color: #4A90E2;margin-left: 10px;">单位：万元</span></p>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="7">
                    <el-col :span="8">
                        <el-col id="echartOne" style="height: 100px"></el-col>
                        <p style="color: #4A90E2">本月达成率</p>
                    </el-col>
                    <el-col :span="16" >
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#DC970A;font-size: 15px;margin:5px 0;margin-left: 20px;">{{monthTarget}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/indicators-icon.png"/>
                                本月指标
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#419DE7;font-size: 15px; margin:5px 0;margin-left: 20px;">{{monthActual}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/actual-icon.png"/>
                                月度销量
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#505D6D;font-size: 15px;margin:5px 0;margin-left: 20px;">{{oldYearMonth}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/sales-icon.png"/>
                                销量同期
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#D0021B;font-size: 15px; margin:5px 0;margin-left: 20px;">{{monthLv}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/growth-icon.png"/>
                                增长率
                            </p>
                        </el-col>
                    </el-col>


                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 0 auto"></div>
                </el-col>
                <el-col :span="7" >
                    <el-col :span="8">
                        <el-col id="echartTwo" style="height: 100px"></el-col>
                        <p style="color: #4A90E2">季度达成率</p>
                    </el-col>
                    <el-col :span="16" >
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#DC970A;font-size: 15px;margin:5px 0;margin-left: 20px;">{{quarterTargetSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/indicators-icon.png"/>
                                季度指标
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#419DE7;font-size: 15px; margin:5px 0;margin-left: 20px;">{{quarterActualSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/actual-icon.png"/>
                                季度销量
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#505D6D;font-size: 15px;margin:5px 0;margin-left: 20px;">{{oldQuarterActualSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/sales-icon.png"/>
                                销量同期
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#D0021B;font-size: 15px; margin:5px 0;margin-left: 20px;">{{quarterLv}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/growth-icon.png"/>
                                增长率
                            </p>
                        </el-col>
                    </el-col>


                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 0 auto"></div>
                </el-col>
                <el-col :span="7">
                    <el-col :span="8">
                        <el-col id="echartThree" style="height: 100px"></el-col>
                        <p style="color: #4A90E2">年度达成率</p>
                    </el-col>
                    <el-col :span="16">
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#DC970A;font-size: 15px;margin:5px 0;margin-left: 20px;">{{yearTargetSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/indicators-icon.png"/>
                                年度指标
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#419DE7;font-size: 15px; margin:5px 0;margin-left: 20px;">{{yearActualSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/actual-icon.png"/>
                                年度销量
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#505D6D;font-size: 15px;margin:5px 0;margin-left: 20px;">{{oldYearActualSum}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/sales-icon.png"/>
                                销量同期
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#D0021B;font-size: 15px; margin:5px 0;margin-left: 20px;">{{yearLv}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/growth-icon.png"/>
                                增长率
                            </p>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 10px;">
                            <p style="color:#505D6D;font-size: 15px; margin:5px 0;margin-left: 20px;">{{allYearProgress}}</p>
                            <p style="color: #4A4A4A;font-size: 15px;margin:5px 0;">
                                <img src="../../../assets/images/progress-icon.png"/>
                                全年进度
                            </p>
                        </el-col>
                    </el-col>


                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">MTD</p>
                </el-col>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">QTD</p>
                </el-col>
                <el-col :span="8">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">YTD</p>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-table v-if="role=='staff'"
                            :data="tableData"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="客户名称"
                                sortable
                                >
                        </el-table-column>
                        <el-table-column
                                prop="targetamount"
                                sortable
                                label="指标/万元">
                        </el-table-column>
                        <el-table-column
                                prop="forecastamount"
                                sortable
                                label="预估/万元">
                        </el-table-column>
                        <el-table-column
                                prop="actualamount"
                                sortable
                                label="销量/万元">
                        </el-table-column>
                        <el-table-column
                                prop="dcLv"
                                sortable
                                label="达成率">
                        </el-table-column>
                        <el-table-column
                                prop="oldGrowth"
                                sortable
                                label="同比增长">
                        </el-table-column>
                        <el-table-column
                                prop="lastGrowth"
                                sortable
                                label="环比增长">
                        </el-table-column>
                        <el-table-column
                                prop="yearProgress"
                                sortable
                                label="全年指标进度"
                                width="180">
                        </el-table-column>
                    </el-table>
                    <el-table v-if="role!='staff'"
                            :data="tableData"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="姓名"
                                sortable
                        >
                        </el-table-column>
                        <el-table-column
                                prop="targetamount"
                                sortable
                                label="指标/万元">
                        </el-table-column>
                        <el-table-column
                                prop="forecastamount"
                                sortable
                                label="预估/万元">
                        </el-table-column>
                        <el-table-column
                                prop="actualamount"
                                sortable
                                label="销量/万元">
                        </el-table-column>
                        <el-table-column
                                prop="dcLv"
                                sortable
                                label="达成率">
                        </el-table-column>
                        <el-table-column
                                prop="oldGrowth"
                                sortable
                                label="同比增长">
                        </el-table-column>
                        <el-table-column
                                prop="lastGrowth"
                                sortable
                                label="环比增长">
                        </el-table-column>
                        <el-table-column
                                prop="yearProgress"
                                sortable
                                label="全年指标进度"
                                width="180">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'
    import check from '../../../assets/images/check.png'
    import popedom from "./popedom"
    import reportMonth from "./reportMonth"
    export default {
        name: "SalesStatistical",
        data() {
            return {
                conditionsForm:{
                    month:'',
                    productArray:[]
                },
                productOptions:[],
                tableData: [],
                value1:[],
                echartOne:'',
                echartTwo:'',
                echartThree:'',
                month:'',
                date:'',
                yearsDate:'',
                role:'',
                year:'',
                productList:[],
                monthTarget:0,
                monthActual:0,
                oldYearMonth:0,
                monthLv:0+'%',
                quarterTargetSum:0,
                quarterActualSum:0,
                oldQuarterActualSum:0,
                quarterLv:0+'%',
                yearActualSum:0,
                yearTargetSum:0,
                oldYearActualSum:0,
                yearLv:0+'%',
                allYearProgress:0+'%',
                loading:false
            }
        },
        components: {
            popedom,
            reportMonth
        },
        created () {
            this.yearsDate=moment(this.GLOBAL.date).format('YYYY年M月')
            this.role = this.$store.getters.getUser.role
            this.year=new Date().Format('yyyy')
            this.getProductList()
        },
        mounted () {
            this.getSalesInfo_m()
            this.getSalesInfo_q()
            this.getSalesInfo_y()
        },
        updated(){
        },
        methods: {
            handleSelectInputClick(){
                this.getProductList()
                this.getSalesInfo_m()
                this.getSalesInfo_q()
                this.getSalesInfo_y()
            },
            shelfData(){
                this.getProductList()
                this.getSalesInfo_m()
                this.getSalesInfo_q()
                this.getSalesInfo_y()
            },
            //产品选项
            async getProductList(){
                try{
                    let data={
                        territory_id:this.GLOBAL.territory_id,
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYYMM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/SalesStatistical/getProductList',data).then(res=>{
                        if(res.success){
                            this.productList=res.data
                        }

                    })
                    this.value1=''
                }catch (e) {
                    return e
                }
            },
            //获取当月表格数据以及MTD
            async getSalesInfo_m(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                this.loading = true
                try{
                    let data={
                        territory_id:this.GLOBAL.territory_id,
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYYMM'),
                        mm:moment(this.GLOBAL.date).format('MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        year:this.year,
                        product:this.value1,
                    }
                    await http.post('/wapi/SalesStatistical/getSalesInfo_m',data).then(res=>{
                        if(res.success){
                            let arr=res.data
                             //console.log(res.data,1)
                            let monthTarget=0,monthActual=0,oldYearMonth=0
                            for(let i=0;i<arr.length;i++){
                                let obj=arr[i]
                                //本月指标
                                monthTarget += Number(obj.targetamount)
                                //本月销量
                                monthActual += Number(obj.actualamount)
                                //销量同期
                                oldYearMonth += Number(obj.oldactualamount)
                                obj.targetamount= obj.targetamount==0?Number( obj.targetamount):((Number(obj.targetamount))/10000).toFixed(2)
                                obj.forecastamount=obj.forecastamount==0?Number( obj.forecastamount):((Number(obj.forecastamount))/10000).toFixed(2)
                                obj.actualamount=obj.actualamount==0?Number( obj.actualamount):((Number(obj.actualamount))/10000).toFixed(2)
                                obj.dcLv=obj.actualamount==0?0+'%':(Number(obj.actualamount)/Number(obj.targetamount)*100).toFixed(2)+'%'
                                //同比增长
                                obj.oldGrowth=obj.actualamount==0||obj.oldactualamount==0?0+'%':Number(obj.actualamount)-Number(obj.oldactualamount)/Number(obj.oldactualamount)+'%'
                                //环比增长
                                obj.lastGrowth=obj.lastactualamount==0||obj.lastactualamount==undefined?0+'%':Number(obj.actualamount)-Number(obj.lastactualamount)/Number(obj.lastactualamount)+'%'
                                obj.yearProgress=obj.all==0||obj.toAmount==0?0+'%':(obj.toAmount/obj.all*100).toFixed(2)+'%'
                            }
                            this.monthTarget=(monthTarget/10000).toFixed(2)
                            this.monthActual=(monthActual/10000).toFixed(2)
                            this.oldYearMonth=(oldYearMonth/10000).toFixed(2)
                            //增长率
                            this.monthLv=this.monthActual==0||this.oldYearMonth==0?0+'%':(this.monthActual-this.oldYearMonth)/this.oldYearMonth*100+'%'
                            this.tableData=arr
                            this.echartOne=this.$echarts.init(document.getElementById('echartOne'))
                            this.echartOne.setOption({
                                color:['#419DE7', '#d9ebfa'],
                                series: [
                                    {
                                        type: 'pie',
                                        center: ['40%', '40%'],
                                        radius: ['70%', '80%'],
                                        avoidLabelOverlap: false,
                                        hoverAnimation: false,
                                        label: {
                                            normal: {
                                                show: true,
                                                position: 'center',
                                                formatter: '{w|{d}%}',
                                                rich:{
                                                    w:{
                                                        fontSize:16,
                                                        fontWeight:'bold'
                                                    },
                                                }
                                            }
                                        },
                                        labelLine: {
                                            normal: {
                                                show: false
                                            }
                                        },
                                        data:[{
                                            value: this.monthActual,
                                        },
                                            {
                                                value: this.monthTarget,
                                                label: {
                                                    normal: {
                                                        show: false
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            })
                        }
                        // if(res.data.length>0){
                        //     loading.close()
                        // }
                    })
                }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            },
            //获取QTD
            async getSalesInfo_q(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                try {
                    let data={
                        territory_id:this.GLOBAL.territory_id,
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYYMM'),
                        mm:moment(this.GLOBAL.date).format('MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        year:this.year,
                        product:this.value1,
                    }
                    await http.post('/wapi/SalesStatistical/getSalesInfo_q',data).then(res=>{
                        if(res.success){
                            console.log(res.data,3333)

                            let quarterArr=res.data
                            let quarterTargetSum=0,quarterActualSum=0,oldQuarterActualSum=0
                            for(let i=0;i<quarterArr.length;i++){
                                let obj=quarterArr[i]
                                //季度指标
                                quarterTargetSum+=Number(obj[0].targetamount)
                                //季度销量
                                quarterActualSum+=Number(obj[0].actualamount)
                                //上一年季度销量
                                oldQuarterActualSum+=Number(obj[0].oldactualamount)
                            }
                            this.quarterTargetSum=(quarterTargetSum/10000).toFixed(2)
                            this.quarterActualSum=(quarterActualSum/10000).toFixed(2)
                            this.oldQuarterActualSum=(oldQuarterActualSum/10000).toFixed(2)
                            this.quarterLv=this.quarterActualSum==0||this.oldQuarterActualSum==0?0+'%':
                                (this.quarterActualSum-this.oldQuarterActualSum)/this.oldQuarterActualSum*100+'%'
                            this.echartTwo=this.$echarts.init(document.getElementById('echartTwo'))
                            this.echartTwo.setOption({
                                color:['#419DE7', '#d9ebfa'],
                                series: [
                                    {
                                        type: 'pie',
                                        center: ['40%', '40%'],
                                        radius: ['70%', '80%'],
                                        avoidLabelOverlap: false,
                                        hoverAnimation: false,
                                        label: {
                                            normal: {
                                                show: true,
                                                position: 'center',
                                                formatter: '{w|{d}%}',
                                                rich:{
                                                    w:{
                                                        fontSize:16,
                                                        fontWeight:'bold'
                                                    },
                                                }
                                            }
                                        },
                                        labelLine: {
                                            normal: {
                                                show: false
                                            }
                                        },
                                        data:[{
                                            value: this.quarterActualSum,
                                        },
                                            {
                                                value: this.quarterTargetSum,
                                                label: {
                                                    normal: {
                                                        show: false
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            })
                            // console.log(quarterArr,123)
                        }else {
                            // loading.close()
                            this.loading = false
                        }
                    })
                }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            },
            //获取YTD
            async getSalesInfo_y(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                try{
                    let data={
                        territory_id:this.GLOBAL.territory_id,
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYYMM'),
                        mm:moment(this.GLOBAL.date).format('MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        year:this.year,
                        product:this.value1,
                    }
                    await http.post('/wapi/SalesStatistical/getSalesInfo_y',data).then(res=>{
                        if(res.success){
                            //console.log(res.data,44)
                            let array=res.data
                            let selectArr=array.selectArr
                            let yearArr=array.yearArr
                            let yearActualSum=0,yearTargetSum=0,oldYearActualSum=0,allTargetSum=0
                            for(let i=0;i<selectArr.length;i++){
                                let obj=selectArr[i]
                                //年度销量
                                yearActualSum+=Number(obj[0].actualamount)
                                //年度指标
                                yearTargetSum+=Number(obj[0].targetamount)
                                //上一年销量
                                oldYearActualSum+=Number(obj[0].oldactualamount)
                            }
                            for(let i=0;i<yearArr.length;i++){
                                let obj=yearArr[i]
                                //全年指标
                                allTargetSum+=Number(obj[0].targetamount)
                            }
                            this.yearTargetSum=(yearTargetSum/10000).toFixed(2)
                            this.yearActualSum=(yearActualSum/10000).toFixed(2)
                            this.oldYearActualSum=(oldYearActualSum/10000).toFixed(2)
                            this.yearLv=this.yearActualSum==0||this.oldYearActualSum==0?0+'%':
                                (this.yearActualSum-this.oldYearActualSum)/this.oldYearActualSum*100+'%'
                            this.allYearProgress=this.yearActualSum==0||this.allTargetSum==0?0+'%':
                                ((yearActualSum/allTargetSum)*100).toFixed(2)+'%'
                            this.echartThree=this.$echarts.init(document.getElementById('echartThree'))
                            this.echartThree.setOption({
                                color:['#419DE7', '#d9ebfa'],
                                series: [
                                    {
                                        type: 'pie',
                                        center: ['40%', '40%'],
                                        radius: ['70%', '80%'],
                                        avoidLabelOverlap: false,
                                        hoverAnimation: false,
                                        label: {
                                            normal: {
                                                show: true,
                                                position: 'center',
                                                formatter: '{w|{d}%}',
                                                rich:{
                                                    w:{
                                                        fontSize:16,
                                                        fontWeight:'bold'
                                                    },
                                                }
                                            }
                                        },
                                        labelLine: {
                                            normal: {
                                                show: false
                                            }
                                        },
                                        data:[{
                                            value: this.yearActualSum,
                                        },
                                            {
                                                value: this.yearTargetSum,
                                                label: {
                                                    normal: {
                                                        show: false
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            })
                            this.loading = false
                        }else {
                            // loading.close()
                            this.loading = false
                        }

                    })
                }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            },
            searchWeekList(){
                this.GLOBAL.date = this.date
                this.yearsDate=moment(this.GLOBAL.date).format('YYYY年M月')
                this.getSalesInfo_y()
                this.getSalesInfo_m()
                this.getSalesInfo_q()
            },
            handleSelectInput(j){
                this.date=j
            },
            ResetClick(){
                this.GLOBAL.date=''
                this.value1=''
            },
            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = [ '客户名称', '指标/万元', '预估/万元', '销量/万元','达成率','同比增长','环比增长','全年指标进度']
                        const filterVal = [
                            'name',
                            'targetamount',
                            'forecastamount',
                            'actualamount',
                            'dcLv',
                            'oldGrowth',
                            'lastGrowth',
                            'yearProgress',
                        ]
                        const list = this.tableData
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '销售数据表',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        },

    }
</script>

<style scoped>
    /*#SalesStatistical {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #SalesStatistical >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #SalesStatistical >>>.el-table th{
        padding: 7px 0px;
    }
    #SalesStatistical >>>.el-table td{
        padding: 7px 0px;
    }


</style>



// WEBPACK FOOTER //
// src/pages/statement/components/SalesStatistical.vue